module.exports = __webpack_public_path__ + "static/media/a-donde-quieres-icon.47fc73ee.svg";